import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Storage from "../../utils/storage";
import { useHistory } from "react-router-dom";
import { Form, Formik, Field } from "formik";
import * as moment from "moment";
import FormSelect3 from "../../components/FormSelect/FormSelect3";
import FormInput3 from "../../components/FormInput/FormInput3";
import { RegisterDeviceSchema } from "../../utils/validation";
import Logo from "../../assets/assets/Nibss-Logo.png";
import Button2 from "../../components/Button/Button2";
import Button3 from "../../components/Button/Button3";
import SingleDateFilter from "../../components/DateFilter/SingleDateFilter";
import { uploadPosDeviceDetails } from "../../redux/Actions/PosActions";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";
import jwt_decode from "jwt-decode";
import { PropTypes } from "prop-types";

const ApplicationForm = ({
  isRegistering,
  appStatus,
  registerDevice,
  registeredSuccess,
  getStatus,
  newDevice
}) => {
  const history = useHistory();

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let name = user && user.name;

  let userToken = Storage.get("user-access-token");
  const token = jwt_decode(userToken)
  let userCompanyId = token && token.id



  useEffect(
    () => {
      getStatus();
    },
    // eslint-disable-next-line
    [getStatus]
  );

  const [state, setState] = useState({
    form1: true,
    form2: false,
    form3: false,
    form4: false,
    emv_level_one: "",
    emv_level_two: "",
    tqm: "",
    pci: "",
    disableOther: "",
  });

  const form1 = () => {
    setState({
      ...state,
      form1: true,
      form2: false,
      form3: false,
      form4: false,
    });
  };

  const form2 = () => {
    setState({
      ...state,
      form1: false,
      form2: true,
      form3: false,
      form4: false,
    });
  };

  const form3 = () => {
    setState({
      ...state,
      form1: false,
      form2: false,
      form3: true,
      form4: false,
    });
  };

  const form4 = () => {
    setState({
      ...state,
      form1: false,
      form2: false,
      form3: false,
      form4: true,
    });
  };

  const cameraOptions = [
    {
      id: 1,
      name: "Available",
      value: "Available",
      disabled: false,
    },
    {
      id: 2,
      name: "Not Available",
      value: "Not Available",
      disabled: false,
    },
  ];
  const osOptions = [
    {
      id: 1,
      name: "Android",
      value: "Android",
      disabled: false,
    },
    {
      id: 2,
      name: "Linux",
      value: "Linux",
      disabled: false,
    },
  ];

  const cardOptions = [
    {
      id: 1,
      name: "Yes",
      value: "true",
      disabled: false,
    },
    {
      id: 2,
      name: "No",
      value: "false",
      disabled: false,
    },
  ];

  const goToApply = () => {
    history.push("/apply");
  };

  const initialValues = {
    device_name: "",
    device_model: "",
    manufacturer_name: "",
    application_name: "",
    version: "",
    operating_system: "",
    is_card_reader: "",
    card_reader_spec: "",
    communication_spec: "",
    camera: "",
    camera_spec: "",
    emv_level_one_date: "",
    emv_level_two_date: "",
    tqm_date: "",
    pci_date: "",
    biometric_spec: "",
    cpu_spec: "",
    keypad_spec: "",
    display_spec: "",
    printer_spec: "",
    power_size: "",
    other_spec: "",
    multi_application_spec: "",
    device_longitude: "",
    device_latitude: "",
    posDevice_type: ""
  };

  const [emvDate, setEMVL1Date] = useState(null);
  const [emv2Date, setEMVL2Date] = useState(null);
  const [tqmDate, setTQMDate] = useState(null);
  const [pciDate, setPCIDate] = useState(null);

  const setState1 = (date) => {
    setEMVL1Date(date);
    setState({
      ...state,
      emv_level_one: moment(date).format("YYYY-MM-DD"),
    });
  };

  const setState2 = (date) => {
    setEMVL2Date(date);
    setState({
      ...state,
      emv_level_two: moment(date).format("YYYY-MM-DD"),
    });
  };

  const setState3 = (date) => {
    setTQMDate(date);
    setState({
      ...state,
      tqm: moment(date).format("YYYY-MM-DD"),
    });
  };

  const setState4 = (date) => {
    setPCIDate(date);
    setState({
      ...state,
      pci: moment(date).format("YYYY-MM-DD"),
    });
  };

  const submitApplication = (value) => {
   
    value.emv_level_one_date = state.emv_level_one;
    value.emv_level_two_date = state.emv_level_two;
    value.tqm_date = state.tqm;
    value.pci_date = state.pci;

    if (value.is_card_reader === "false") {
      value.card_reader_spec = "Nil";
    }
    if (value.camera === "Not Available") {
      value.camera_spec = "Nil";
    }
    const application = {
      company_id: userCompanyId,
      device_name: value.device_name,
      device_model: value.device_model,
      manufacturer_name: value.manufacturer_name,
      application_name: value.application_name,
      version: value.version,
      operating_system: value.operating_system,
      is_card_reader: value.is_card_reader,
      card_reader_spec: value.card_reader_spec,
      communication_spec: value.communication_spec,
      camera: value.camera,
      camera_spec: value.camera_spec,
      emv_level_one_date: value.emv_level_one_date,
      emv_level_two_date: value.emv_level_two_date,
      tqm_date: value.tqm_date,
      pci_date: value.pci_date,
      biometric_spec: value.biometric_spec,
      cpu_spec: value.cpu_spec,
      keypad_spec: value.keypad_spec,
      display_spec: value.display_spec,
      printer_spec: value.printer_spec,
      power_size: value.power_size,
      other_spec: value.other_spec,
      multi_application_spec: value.multi_application_spec,
      device_longitude: value.device_longitude,
      device_latitude: value.device_latitude,
      posDevice_type: value.posDevice_type
    };
    registerDevice(application)
  };

  useEffect(() => {
    if (registeredSuccess) {
      const appId = newDevice && newDevice.application_id
      history.push({
        pathname: "/device/upload",
        state: {
          id: appId
        },
      });
    }
  },
  // eslint-disable-next-line
  [registeredSuccess, history, newDevice]);

  return (
    <div className="application">
      <Link to="/dashboard">
        {" "}
        <div className="application-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>

      <div className="application-start-form">
        <div
          className={
            state.form1
              ? "form1"
              : state.form2
              ? "form2"
              : state.form3
              ? "form3"
              : "full"
          }
        ></div>
        {state.form1 ? (
          <div className="application-start-form-header">
            <h1>Hello {name}</h1>
            <h3>
              Let's get you <br /> started
            </h3>
            <p>Provide the information of the POS Device</p>
          </div>
        ) : state.form2 ? (
          <div className="application-start-form-header">
            <h1>Hello {name}</h1>
            <h3>
              Tell us more about
              <br /> the Device
            </h3>
            <p>Provide the parameters of the POS Device</p>
          </div>
        ) : state.form3 ? (
          <div className="application-start-form-header">
            <h1>
              Hello {name}, <span> you are almost there</span>
            </h1>
            <h3>
              Tell us detailed validity
              <br /> dates
            </h3>
            <p>Provide the parameters for all validity dates</p>
          </div>
        ) : (
          <div className="application-start-form-header">
            <h1>Hello {name}</h1>
            <h3>
              Finally, tell us detailed
              <br /> component specifications
            </h3>
            <p>Provide the parameters for all component specifications</p>
          </div>
        )}

        <div className="application-wrap">
          <Formik
            initialValues={initialValues}
            validationSchema={RegisterDeviceSchema}
            onSubmit={submitApplication}
          >
            {({ values, isValid, dirty }) => {
              const disable1 =
                values.device_name.length < 3 ||
                values.device_model.length < 3 ||
                values.manufacturer_name.length < 3 ||
                values.application_name.length < 3 ||
                values.version.length < 2 ||
                values.operating_system.length < 2;
              const disable2 =
                values.is_card_reader === "" ||
                values.communication_spec.length < 3 ||
                values.camera === "";
              const disable3 =
                state.emv_level_one === "" ||
                state.emv_level_two === "" ||
                state.tqm === "" ||
                state.pci === "";
              return (
                <Form id="form">
                  {state.form1 ? (
                    <div className="form-1">
                      <div className="app-input">
                        <Field
                          name="device_name"
                          label="POS Device Name"
                          placeholder="Enter POS device name"
                          component={FormInput3}
                        />
                      </div>

                      <div className="app-input">
                        <Field
                          name="device_model"
                          label="POS Device Model"
                          placeholder="Enter POS device model"
                          component={FormInput3}
                        />
                      </div>

                      <div className="app-input">
                        <Field
                          name="manufacturer_name"
                          label="POS Manufacturer Name"
                          placeholder="Enter POS manufacturer name"
                          component={FormInput3}
                        />
                      </div>

                      <div className="app-input">
                        <Field
                          name="application_name"
                          label="Certified Application Name"
                          placeholder="Enter certified application name"
                          component={FormInput3}
                        />
                      </div>
                      <div className="app-input">
                      <Field
                        name="device_longitude"
                        label="Specify Certified Device Longitude Coordinates"
                        placeholder="Specify certified device longitude coordinates"
                        component={FormInput3}
                      />
                    </div>

                    <div className="app-input">
                      <Field
                        name="device_latitude"
                        label="Specify Certified Device Latitude Coordinates"
                        placeholder="Specify certified device latitude coordinates"
                        component={FormInput3}
                      />
                    </div>

                    <div className="app-input2">
                        <Field name="posDevice_type">
                          {(val) => (
                            <FormSelect3
                              id="formselect"
                              options={osOptions}
                              label="POS OS Device Type"
                              placeholder="Select Option"
                              {...val}
                            />
                          )}
                        </Field>
                      </div>

                      <div className="app-input">
                        <Field
                          name="version"
                          label="Specify Version of POS Application"
                          placeholder="Enter version of POS application"
                          component={FormInput3}
                        />
                      </div>

                      <div className="app-input">
                        <Field
                          name="operating_system"
                          label="Specify the Device OS(operating system)"
                          placeholder="Enter device OS"
                          component={FormInput3}
                        />
                      </div>

                      <div className="application-wrap-buttons">
                        <Button2
                          width="45%"
                          height="45px"
                          word={"Back"}
                          onClick={goToApply}
                        />
                        <Button3
                          width="45%"
                          height="45px"
                          word={"Proceed"}
                          onClick={form2}
                          type={"button"}
                          disabled={disable1}
                        />
                      </div>
                    </div>
                  ) : state.form2 ? (
                    <div className="form-1">
                      <br/>
                      <div className="app-input">
                        <Field name="is_card_reader">
                          {(val) => (
                            <FormSelect3
                              id="formselect"
                              options={cardOptions}
                              label="Card Readers"
                              placeholder="Select Option"
                              {...val}
                            />
                          )}
                        </Field>
                      </div>
                      {values.is_card_reader === "true" && (
                        <div className="app-input">
                          <Field
                            name="card_reader_spec"
                            label="If Yes, State The Specification"
                            type="text"
                            placeholder="Enter POS manufacturer name"
                            component={FormInput3}
                          />
                        </div>
                      )}

                      <div className="app-input3">
                        <Field
                          name="communication_spec"
                          label="Communications"
                          type="text"
                          placeholder="Enter Communications spec"
                          component={FormInput3}
                        />
                      </div>

                      <div className="app-input2">
                        <Field name="camera">
                          {(val) => (
                            <FormSelect3
                              id="formselect"
                              options={cameraOptions}
                              label="Camera"
                              placeholder="Select Option"
                              {...val}
                            />
                          )}
                        </Field>
                      </div>

                      {values.camera === "Available" && (
                        <div className="app-input3">
                          <Field
                            name="camera_spec"
                            label="Camera Spec"
                            type="text"
                            placeholder="Enter Camera spec"
                            component={FormInput3}
                          />
                        </div>
                      )}

                      <div className="application-wrap-buttons">
                        <Button2
                          width="45%"
                          height="45px"
                          word={"Back"}
                          onClick={form1}
                        />
                        <Button3
                          width="45%"
                          height="45px"
                          word={"Proceed"}
                          onClick={form3}
                          type={"button"}
                          disabled={
                            disable2 ||
                            (values.camera === "Available" &&
                              values.camera_spec === "") ||
                            (values.is_card_reader === "true" &&
                              values.card_reader_spec === "")
                          }
                        />
                      </div>
                    </div>
                  ) : state.form3 ? (
                    <div className="form-1">
                      <div className="app-input">
                        <Field name="emv_level_one_date">
                          {() => (
                            <SingleDateFilter
                              subLabel="EMV - L1"
                              label="- Provide Validity Dates"
                              placeholder="Choose Date"
                              setDate={setEMVL1Date}
                              onChange={setState1}
                              fixedDate={emvDate}
                            />
                          )}
                        </Field>
                      </div>

                      <div className="app-input">
                        <Field name="emv_level_two_date">
                          {() => (
                            <SingleDateFilter
                              subLabel="EMV - L2"
                              label="- Provide Validity Dates"
                              placeholder="Choose Date"
                              setDate={setEMVL2Date}
                              onChange={setState2}
                              fixedDate={emv2Date}
                            />
                          )}
                        </Field>
                      </div>

                      <div className="app-input">
                        <Field name="tqm_date">
                          {() => (
                            <SingleDateFilter
                              subLabel="TQM"
                              label="- Provide Validity Dates"
                              placeholder="Choose Date"
                              setDate={setTQMDate}
                              onChange={setState3}
                              fixedDate={tqmDate}
                            />
                          )}
                        </Field>
                      </div>

                      <div className="app-input">
                        <Field name="pci_date">
                          {() => (
                            <SingleDateFilter
                              subLabel="PCI PED/PTS"
                              label="- Provide Validity Dates"
                              placeholder="Choose Date"
                              setDate={setPCIDate}
                              onChange={setState4}
                              fixedDate={pciDate}
                            />
                          )}
                        </Field>
                      </div>

                      <div className="application-wrap-buttons">
                        <Button2
                          width="45%"
                          height="45px"
                          word={"Back"}
                          onClick={form2}
                        />
                        <Button3
                          width="45%"
                          height="45px"
                          word={"Proceed"}
                          onClick={form4}
                          type={"button"}
                          disabled={disable3}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="form-1">
                      <div className="app-input">
                        <div className="app-input">
                          <Field
                            name="biometric_spec"
                            label="- State the specification"
                            subLabel="Biometric"
                            placeholder="Enter biometric specification"
                            component={FormInput3}
                          />
                        </div>
                        <div className="app-input">
                          <Field
                            name="cpu_spec"
                            label="- State the specification"
                            subLabel="CPU"
                            placeholder="Enter CPU specification"
                            component={FormInput3}
                          />
                        </div>
                        <div className="app-input">
                          <Field
                            name="keypad_spec"
                            label="- State the specification"
                            subLabel="Keypad"
                            placeholder="Enter keypad specification"
                            component={FormInput3}
                          />
                        </div>
                        <div className="app-input">
                          <Field
                            name="display_spec"
                            label="- State the specification"
                            subLabel="Display"
                            placeholder="Enter display specification"
                            component={FormInput3}
                          />
                        </div>
                        <div className="app-input">
                          <Field
                            name="power_size"
                            label="- State the specification"
                            subLabel="Power"
                            placeholder="Enter power specification"
                            component={FormInput3}
                          />
                        </div>
                        <div className="app-input">
                          <Field
                            name="printer_spec"
                            label="- State the specification"
                            subLabel="Printer"
                            placeholder="Enter printer specification"
                            component={FormInput3}
                          />
                        </div>
                        <div className="app-input">
                          <Field
                            name="multi_application_spec"
                            label="- State the specification"
                            subLabel="Multi-Application"
                            placeholder="Enter multi-application specification"
                            component={FormInput3}
                          />
                        </div>
                        <div className="app-input">
                          <Field
                            name="other_spec"
                            label="- State the specification"
                            subLabel="Customization/Others"
                            placeholder="Enter customization/others specification"
                            component={FormInput3}
                          />
                        </div>
                      </div>

                      <div className="application-wrap-buttons">
                        <Button2
                          width="45%"
                          height="45px"
                          word={"Back"}
                          onClick={form3}
                        />
                        <Button3
                          width="45%"
                          height="45px"
                          word={"Submit"}
                          type="submit"
                          disabled={
                            disable3 || !(isValid && dirty) || isRegistering
                          }
                        />
                      </div>
                    </div>
                  )}
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isRegistering: state.pos.isRegistering,
    registeredSuccess: state.pos.registeredSuccess,
    newDevice: state.pos.newDevice,
    appStatus: state.docs.status,
  };
};

const mapDispatchToProps = (dispatch) => ({
  registerDevice: (payload) => dispatch(uploadPosDeviceDetails(payload)),
  getStatus: () => dispatch(getUserStatus()),
});

ApplicationForm.propTypes = {
  appStatus: PropTypes.array,
  getStatus: PropTypes.func,
  isRegistering: PropTypes.bool,
  newDevice: PropTypes.object,
  registerDevice: PropTypes.func,
  registeredSuccess: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationForm);
